'use client';

import { init, tag } from '@blotoutio/edgetag-sdk-js';
import facebook from '@blotoutio/providers-facebook-sdk';
import googleAdsClicks from '@blotoutio/providers-google-ads-clicks-sdk';
import ga4 from '@blotoutio/providers-google-analytics-4-sdk';
import { isProduction } from '@qlevr/shared/utilities';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export function BlotoutAnalytics({ edgeURL }: { edgeURL: string }) {
  const pathname = usePathname();
  const isInitialized = useRef(false);
  const lastTrackedPathname = useRef<string | null>(null);

  useEffect(() => {
    if (!isProduction()) {
      return;
    }

    if (!isInitialized.current) {
      init({
        edgeURL: edgeURL,
        disableConsentCheck: true,
        providers: [facebook, ga4, googleAdsClicks],
      });
      isInitialized.current = true;
    }
  }, [edgeURL]);

  useEffect(() => {
    // Ensure PageView is triggered only once per unique pathname
    if (lastTrackedPathname.current !== pathname) {
      lastTrackedPathname.current = pathname;
      tag('PageView');
    }
  }, [pathname]);

  return null;
}

export default BlotoutAnalytics;
